import { createFeatureSelector } from '@ngrx/store';
import { BOOKING_LIST_STORE_NAME, BookingListState } from './booking-list.state';

export const getDataBookingList = createFeatureSelector<BookingListState>(BOOKING_LIST_STORE_NAME);
